
import gql from 'graphql-tag';
import QuickGuideWrapper from '../../../components/quick-guide/QuickGuideWrapper.vue';
import productPromotionFragment from '~/apollo/fragments/productPromotionFragment';
import annuityPlanScenariosQuery from '~/apollo/queries/product/annuityPlanScenarios';
import insuranceCompaniesQuery from '~/apollo/queries/product/insuranceCompanies';
import annuityTooltips from '~/apollo/queries/product/tooltips/annuityTooltips';
import commonProductMixins from '~/mixins/commonProductMixins.js';
import productPromotionMixins from '~/mixins/productPromotionMixins.js';
import apolloQuickGuideMixins from '~/mixins/apolloQuickGuideMixins';
import productInsuranceNameMixins from '~/mixins/productInsuranceNameMixins';
import productShortcutMixins from "~/mixins/productShortcutMixins.js";
import ComparisonMobileContentSection from '~/components/products/comparison/Content/ComparisonMobileContentSection.vue';

export default {
  name: 'ProductsDeferredAnnuityListingPage',
  mixins: [commonProductMixins, productPromotionMixins, apolloQuickGuideMixins, productInsuranceNameMixins, productShortcutMixins],

  apollo: {
    $loadingKey: 'loading',
    annuityPlanScenarios: {
      query: gql`
        ${annuityPlanScenariosQuery}
        ${productPromotionFragment}
      `,
      prefetch: true,
      variables() {
        let tmpComp;
        tmpComp = undefined;
        let tmpShowLongevity;
        tmpShowLongevity = undefined;
        let tmpShowSavings;
        tmpShowLongevity = undefined;
        // let tmpShowRetirement;
        // tmpShowRetirement = undefined;
        let tmpShowStableRetirement;
        tmpShowStableRetirement = undefined;
        let tmpShowGrowthRetirement;
        tmpShowGrowthRetirement = undefined;
        let tmpLocale;
        tmpLocale = undefined;
        const tmpTotalPremium = undefined;
        let tmpSelection;
        tmpSelection = undefined;
        let tmpIncomeTermFrom;
        tmpIncomeTermFrom = undefined;
        let tmpIncomeTermTo;
        tmpIncomeTermTo = undefined;

        if (this.filter.insCompValue?.length) {
          tmpComp = this.filter.insCompValue.map((x) => x.value);
        }

        if (this.filter.objectiveValue?.value === 'savings') {
          tmpShowSavings = true;
        } else if (this.filter.objectiveValue?.value === 'stable_retirement_income') {
          tmpShowStableRetirement = true;
        } else if (this.filter.objectiveValue?.value === 'growth_retirement_income') {
          tmpShowGrowthRetirement = true;
        }
        else {
          tmpShowLongevity = true;
        }

        if (this.currentLocale) {
          tmpLocale = this.currentLocale;
        }

        if (this.filter.selectionSelected) {
          tmpSelection = this.filter.selectionSelected;
        }
        // console.log(this.filter.incomeTermValue[this.filter.objectiveValue.value])

        if (this.filter.incomeTermValue[this.filter.objectiveValue.value].value === '10') {
          tmpIncomeTermFrom = 0;
          tmpIncomeTermTo = 10;
        }
        if (this.filter.incomeTermValue[this.filter.objectiveValue.value].value === '20') {
          tmpIncomeTermFrom = 15;
          tmpIncomeTermTo = 20;
        }
        if (this.filter.incomeTermValue[this.filter.objectiveValue.value].value === '20+') {
          tmpIncomeTermFrom = 20;
          tmpIncomeTermTo = 999;
        }

        return {
          insCompCode: tmpComp,
          age: parseInt(this.filter.issueAgeValue[this.filter.objectiveValue.value].value),
          income_term_start: parseInt(this.filter.startAgeValue[this.filter.objectiveValue.value].value),
          // income_term: this.filter.incomeTermValue[this.filter.objectiveValue.value].value === '-1' ||this.filter.incomeTermValue[this.filter.objectiveValue.value].value === '20+' ? undefined : parseInt(this.filter.incomeTermValue[this.filter.objectiveValue.value].value),
          income_term_above: this.filter.incomeTermValue[this.filter.objectiveValue.value].value === '20+' ? 20 : undefined,
          income_term_from: tmpIncomeTermFrom,
          income_term_to: tmpIncomeTermTo,
          locale: tmpLocale,
          objective: this.filter.objectiveValue?.value,
          currency: parseInt(this.filter.currencyValue[this.filter.objectiveValue.value].value),
          premium_term: parseInt(this.filter.premiumTermValue[this.filter.objectiveValue.value].value),
          // premium_term_from: parseInt(this.filter.premiumTermValue.value[0]),
          // premium_term_to: parseInt(this.filter.premiumTermValue.value[1]),
          show_longevity: tmpShowLongevity,
          show_savings: tmpShowSavings,
          // show_retirement: tmpShowRetirement,
          show_stable_retirement: tmpShowStableRetirement,
          show_growth_retirement: tmpShowGrowthRetirement,
          total_premium: tmpTotalPremium,
          broker_ind: tmpSelection
        };
      }
    },
    insuranceCompanies: {
      query: insuranceCompaniesQuery,
      prefetch: true,
      variables() {
        return { show_annuity: true };
      },
      update(data) {
        return data.insuranceCompanies.data.map((item) => {
          const translations = item.attributes.insurance_company_translations.data;
          // console.debug(translations);
          const filteredTranslations = this.getFilteredTranslations(translations);
          return {
            value: item.attributes.code,
            text:
              filteredTranslations[0].attributes.name +
              ' | ' +
              filteredTranslations[1].attributes.name,
          };
        });
      }
    },
    annuityTooltips: {
      query: annuityTooltips,
      prefetch: true,
      variables() {
        return { currentlocale: this.$normalizeLocale(this.$i18n.locale) };
      },
      update(data) {
        return this.$normalizeStrapi(data.infoTooltip.data);
      }
    },
  },
  data() {
    return {
      loading: 0,
      currentLocale: this.$normalizeLocale(this.$i18n.locale),

      filter: {
        insCompValue: [],
        selectionSelected: this.$route.query.advisorAssistance !== 'false',

        currencyValue: {
          savings: { value: this.$route.query.currency && !this.$route.query.objective ? this.$route.query.currency : '1', text: 'USD' },
          stable_retirement_income: { value: this.$route.query.currency && this.$route.query.objective === 'stable_retirement_income' ? this.$route.query.currency : '1', text: 'USD' },
          longevity: { value: this.$route.query.currency && this.$route.query.objective === 'longevity' ? this.$route.query.currency : '1', text: 'USD' },
          growth_retirement_income: { value: this.$route.query.currency && this.$route.query.objective === 'growth_retirement_income' ? this.$route.query.currency : '1', text: 'USD' }
        },
        currencyOptions: {
          savings: [{ value: '1', text: 'USD' }],
          stable_retirement_income: [{ value: '1', text: 'USD' }],
          longevity: [
            { value: '1', text: 'USD' },
          ],
          growth_retirement_income: [{ value: '1', text: 'USD' }],
        },

        // objectiveValue: (this.$route!==null && this.$route.query.objective!==null)?this.$route.query.objective:"savings",
        objectiveValue: {
          value: this.$route.query.objective ? this.$route.query.objective : 'savings',
          text: this.$t('products.annuity.objective_savings')
        },

        objectiveOptions: [
          { value: 'savings', text: this.$t('products.annuity.objective_savings') },
          // { value: 'retirement', text: this.$t('products.annuity.objective_retirement') },
          { value: 'stable_retirement_income', text: this.$t('products.annuity.objective_stable_retirement') },
          { value: 'growth_retirement_income', text: this.$t('products.annuity.objective_growth_retirement_income') },
          { value: 'longevity', text: this.$t('products.annuity.objective_longevity') }
        ],

        issueAgeValue: {
          savings: { value: this.$route.query.issue_age && !this.$route.query.objective ? this.$route.query.issue_age : '35', text: '35' },
          stable_retirement_income: { value: this.$route.query.issue_age && this.$route.query.objective === 'stable_retirement_income' ? this.$route.query.issue_age : '45', text: '45' },
          longevity: { value: this.$route.query.issue_age && this.$route.query.objective === 'longevity' ? this.$route.query.issue_age : '45', text: '45' },
          growth_retirement_income: { value: this.$route.query.issue_age && this.$route.query.objective === 'growth_retirement_income' ? this.$route.query.issue_age : '45', text: '45' }
        },
        issueAgeOptions: {
          savings: [
            { value: '35', text: '35' },
            { value: '45', text: '45' }
          ],
          stable_retirement_income: [{ value: '45', text: '45' }],
          longevity: [{ value: '45', text: '45' }],
          growth_retirement_income: [{ value: '45', text: '45' }],
        },

        startAgeValue: {
          savings: { value: this.$route.query.start_age && !this.$route.query.objective ? this.$route.query.start_age : '50', text: '50' },
          stable_retirement_income: { value: this.$route.query.start_age && this.$route.query.objective === 'stable_retirement_income' ? this.$route.query.start_age : '65', text: '65' },
          growth_retirement_income: { value: this.$route.query.start_age && this.$route.query.objective === 'growth_retirement_income' ? this.$route.query.start_age : '65', text: '65' },
          longevity: { value: this.$route.query.start_age && this.$route.query.objective === 'longevity' ? this.$route.query.start_age : '60', text: '60' },
        },
        startAgeOptions: {
          savings: [
            { value: '50', text: '50' },
            { value: '55', text: '55' },
            { value: '60', text: '60' },
            { value: '65', text: '65' },
          ],
          stable_retirement_income: [
            { value: '60', text: '60' },
            { value: '65', text: '65' },
          ],
          longevity: [
            { value: '60', text: '60' },
            { value: '65', text: '65' }
          ],
          growth_retirement_income :[
            { value: '60', text: '60' },
            { value: '65', text: '65' }
          ]
        },

        premiumTermValue: {
          savings: {
            value: this.$route.query.premium_term && !this.$route.query.objective ? this.$route.query.premium_term : '5',
            text: '5 ' + this.$t('products.yearsUnit')
          },
          stable_retirement_income: {
            value: this.$route.query.premium_term && this.$route.query.objective === 'stable_retirement_income' ? this.$route.query.premium_term : '10',
            text: '10 ' + this.$t('products.yearsUnit')
          },
          longevity: {
            value: this.$route.query.premium_term && this.$route.query.objective === 'longevity' ? this.$route.query.premium_term : '10',
            text: '10 ' + this.$t('products.yearsUnit')
          },
          growth_retirement_income: {
            value: this.$route.query.premium_term && this.$route.query.objective === 'growth_retirement_income' ? this.$route.query.premium_term : '10',
            text: '10 ' + this.$t('products.yearsUnit')
          }
        },
        // premiumTermOptions: [
        //   { value: '5', text: '5 ' + this.$t('products.yearsUnit') },
        //   { value: '9', text: '9 ' + this.$t('products.yearsUnit') },
        //   { value: '10', text: '10 ' + this.$t('products.yearsUnit') }
        // ],

        incomeTermValue: {
          savings: { 
            value: '10', 
            text: '10 ' + this.$t('products.yearsUnit') 
          },
          stable_retirement_income: { 
            value: '10', 
            text: '10 ' + this.$t('products.yearsUnit') 
          },
          growth_retirement_income: { 
            value: '20', 
            text: '20 ' + this.$t('products.yearsUnit')
          },
          longevity: { 
            value: '20+',
            text: this.$t('products.annuity.twenty_years_above')
          },
        },
        // incomeTermOptions: this.incomeTermOptionstest
        // incomeTermOptions: this.$route.query.objective == 'longevity' ? 
        // [
        //   { value: '-1', text: this.$t('products.any') },
        //   { value: '20', text: '20 ' + this.$t('products.yearsUnit') },
        //   { value: '20+', text: this.$t('products.annuity.twenty_years_above')  }
        // ]
        // :
        // [
        //   { value: '-1', text: this.$t('products.any') },
        //   { value: '10', text: '10 ' + this.$t('products.yearsUnit') },
        //   { value: '20', text: '20 ' + this.$t('products.yearsUnit') },
        //   { value: '20+', text: this.$t('products.annuity.twenty_years_above')  }
        // ]
      },
      perPage: 15,
      currentPage: 1,
      annuityPlanScenarios: null,
      insuranceCompanies: [],

      sortingData: {
        title: this.$t('products.sort'),
        sortValue: { value: this.$route.query.sort ? this.$route.query.sort : 'five_star', text: '' }
        // sortingOptions: [
        //   {"value":"score","text": this.getScoreLabel()},
        //   {"value":"g_annuity","text": this.$t('products.annuity.as_guaranteedInitialAnnualIncomeHightoLow')},
        //   {"value":"g_irr","text": this.$t('products.annuity.as_guaranteedReturnRatioatAge60HightoLow')},
        //   {"value":"g_bey","text": this.$t('products.annuity.as_guaranteedBreakevenYearShorttoLong')},
        // ],
      },

      querystringUpdateInProgress: false
    };
  },

  computed: {
    modalOpen() {
        return this.$store.getters['modal/showDisplayMobileFilter'].isOpen
    },
    mainQueryLoading() {
      return this.$apollo.queries.annuityPlanScenarios.loading;
    },

    resultMessage() {
      if (this.mainQueryLoading) {
        return this.$t('products.annuity.as_result').replace('$num', '{ }');
      } else {
        // below translation is not implemented yet..
        return this.$t('products.annuity.as_result').replace('$num', this.rows);
      }
    },
    incomeTermOptions() {
      if (this.$route.query.objective == 'longevity') {
        return [
          // { value: '-1', text: this.$t('products.any') },
          // { value: '20', text: '20 ' + this.$t('products.yearsUnit') },
          { value: '20+', text: this.$t('products.annuity.twenty_years_above')  }
        ]
      }
      return [
          // { value: '-1', text: this.$t('products.any') },
          { value: '10', text: '10 ' + this.$t('products.yearsUnit') },
          { value: '20', text: '20 ' + this.$t('products.yearsUnit') },
          { value: '20+', text: this.$t('products.annuity.twenty_years_above')  }
        ]
    },
    premiumTermOptions() {
      return this.$route.query.objective == 'longevity' ?
        [
          { value: '5', text: '5 ' + this.$t('products.yearsUnit') },
          { value: '10', text: '10 ' + this.$t('products.yearsUnit') }
        ] :
        [
          { value: '5', text: '5 ' + this.$t('products.yearsUnit') },
          { value: '9', text: '9 ' + this.$t('products.yearsUnit') },
          { value: '10', text: '10 ' + this.$t('products.yearsUnit') }
        ]
    },

    displayProducts() {
      return this.sortedItem?.map((item) => {
        let mConditionalResult = {};

        if (this.filter.objectiveValue?.value === 'savings') {
          mConditionalResult = {
            showFiveStarBadge: item.overall_star_savings,
            keyItems: [
              {
                value: this.$formatPrice(item.g_initial_annual_income_savings),
                key: this.$t('products.annuity.as_guaranteedInitialAnnualIncome'),
                topSubText: item.currency_code,
                toolTipHtml: '',
                symbolValue: '',
                originalValue: ''
              },
              {
                value: this.$formatPercentage(item.savings_result[0]?.attributes.g_return_ratio),
                key: this.$t('products.annuity.as_guaranteedReturnRatioatAge60'),
                topSubText: '',
                toolTipHtml: this.getTooltipContentByKey('tl_guaranteedReturnRatioatAge60'),
                symbolValue: '',
                originalValue: ''
              },
              {
                value: this.$formatPercentage(item.savings_result[0]?.attributes?.p_return_ratio),
                key: this.$t('products.annuity.as_projectedReturnRatioatAge60'),
                topSubText: '',
                toolTipHtml: this.getTooltipContentByKey('tl_projectedReturnRatioatAge60'),
                symbolValue: '',
                originalValue: ''
              },
              {
                value: item.savings_result[0]?.attributes.gbey,
                key: this.$t('products.annuity.al_guaranteedAnnuityBreakevenYear'),
                topSubText: '',
                toolTipHtml: '',
                symbolValue: '',
                originalValue: ''
              }
            ],
            mobileKeyItems: [
              {
                value: this.$formatPrice(item.g_initial_annual_income_savings),
                key: this.$t('products.annuity.as_guaranteedInitialAnnualIncome'),
                topSubText: item.currency_code,
                toolTipHtml: '',
                symbolValue: '',
                originalValue: '',
                isTextBold: true,
              },
              {
                value: this.$formatPercentage(item.savings_result[0]?.attributes.g_return_ratio),
                key: this.$t('products.annuity.as_guaranteedReturnRatioatAge60'),
                topSubText: '',
                toolTipHtml: this.getTooltipContentByKey('tl_guaranteedReturnRatioatAge60'),
                symbolValue: '',
                originalValue: ''
              },
              {
                value: this.$formatPercentage(item.savings_result[0]?.attributes?.p_return_ratio),
                key: this.$t('products.annuity.as_projectedReturnRatioatAge60'),
                topSubText: '',
                toolTipHtml: this.getTooltipContentByKey('tl_projectedReturnRatioatAge60'),
                symbolValue: '',
                originalValue: ''
              },
              {
                value: item.savings_result[0]?.attributes.gbey,
                key: this.$t('products.annuity.al_guaranteedAnnuityBreakevenYear'),
                topSubText: '',
                toolTipHtml: '',
                symbolValue: '',
                originalValue: ''
              }
            ],
            compactKeyItems: [
              {
                value: this.$formatPercentage(item.savings_result[0]?.attributes.g_return_ratio),
                key: this.$t('products.annuity.as_guaranteedReturnRatioatAge60'),
                topSubText: '',
                toolTipHtml: this.getTooltipContentByKey('tl_guaranteedReturnRatioatAge60'),
                symbolValue: '',
                originalValue: '',
                isTextBlack: true,
              },
              {
                value: item.savings_result[0]?.attributes.gbey,
                key: this.$t('products.annuity.as_guaranteedBreakevenYear'),
                topSubText: '',
                toolTipHtml: '',
                symbolValue: '',
                originalValue: '',
                isTextBlack: false,
              }
            ]
          };
        } else if (this.filter.objectiveValue?.value === 'stable_retirement_income') {
          mConditionalResult = {
            showFiveStarBadge: item.overall_star_stable_retirement,
            keyItems: [
              {
                value: this.$formatPrice(item?.g_initial_annual_income_stable_retirement),
                key: this.$t('products.annuity.ar_guaranteedInitialAnnualIncome'),
                topSubText: item.currency_code,
                toolTipHtml: '',
                symbolValue: '',
                originalValue: ''
              },
              {
                value: this.$formatPercentageDP(item.stable_retirement_result[0]?.attributes.g_return_ratio, 1),
                key: this.getGuaranteedIncomeText,
                // key: this.filter?.incomeTermValue[this.filter?.objectiveValue?.value]?.value === '10' ? this.$t('products.annuity.ar_guaranteedReturnRatioatAge75') : this.$t('products.annuity.ar_guaranteedReturnRatioatAge85'),
                topSubText: '',
                toolTipHtml: this.filter?.incomeTermValue[this.filter?.objectiveValue?.value]?.value === '10' ? this.getTooltipContentByKey('ar_guaranteedReturnRatioatAge75') : this.getTooltipContentByKey('ar_guaranteedReturnRatioatAge85'),
                symbolValue: '',
                originalValue: '',
                isTextBlack: true,
              },
              {
                value: this.$formatPercentageDP(item.stable_retirement_result[0]?.attributes?.p_return_ratio, 1),
                key: this.getProjectedIncomeText,
                topSubText: '',
                toolTipHtml: this.filter?.incomeTermValue[this.filter?.objectiveValue?.value]?.value === '10' ? this.getTooltipContentByKey('ar_projectedReturnRatioatAge75') : this.getTooltipContentByKey('ar_projectedReturnRatioatAge85'),
                symbolValue: '',
                originalValue: '',
                isTextBlack: true,
              },
              {
                value: item.stable_retirement_result[0]?.attributes.gbey,
                key: this.$t('products.annuity.ar_guranteedBreakevenYear'),
                topSubText: '',
                toolTipHtml: '',
                symbolValue: '',
                originalValue: '',
                isTextBlack: true,
              }
            ],
            mobileKeyItems: [
              {
                value: this.$formatPrice(item.g_initial_annual_income_stable_retirement),
                key: this.$t('products.annuity.ar_guaranteedInitialAnnualIncome'),
                topSubText: item.currency_code,
                toolTipHtml: '',
                symbolValue: '',
                originalValue: '',
                isTextBold: true,
              },
              {
                value: this.$formatPercentageDP(item.stable_retirement_result[0]?.attributes.g_return_ratio, 1),
                key: this.getGuaranteedIncomeText,
                topSubText: '',
                toolTipHtml: this.filter?.incomeTermValue[this.filter?.objectiveValue?.value]?.value === '10' ? this.getTooltipContentByKey('ar_guaranteedReturnRatioatAge75') : this.getTooltipContentByKey('ar_guaranteedReturnRatioatAge85'),
                symbolValue: '',
                originalValue: '',
                isTextBlack: true,
              },
              {
                value: this.$formatPercentageDP(item.stable_retirement_result[0]?.attributes?.p_return_ratio, 1),
                key: this.getProjectedIncomeText,
                topSubText: '',
                toolTipHtml: this.filter?.incomeTermValue[this.filter?.objectiveValue?.value]?.value === '10' ? this.getTooltipContentByKey('ar_projectedReturnRatioAge75') : this.getTooltipContentByKey('ar_projectedReturnRatioatAge85'),
                symbolValue: '',
                originalValue: '',
                isTextBlack: true,
              },
              {
                value: item.stable_retirement_result[0]?.attributes.gbey,
                key: this.$t('products.annuity.ar_guranteedBreakevenYear'),
                topSubText: '',
                toolTipHtml: '',
                symbolValue: '',
                originalValue: '',
                isTextBlack: true,
              }
            ],
            compactKeyItems: [
              {
                value: this.$formatPercentageDP(item.stable_retirement_result[0]?.attributes.g_return_ratio, 1),
                key: this.getGuaranteedIncomeText,
                topSubText: '',
                toolTipHtml: this.filter?.incomeTermValue[this.filter?.objectiveValue?.value]?.value === '10' ? this.getTooltipContentByKey('ar_guaranteedReturnRatioatAge75') : this.getTooltipContentByKey('ar_guaranteedReturnRatioatAge85'),
                symbolValue: '',
                originalValue: '',
                isTextBlack: true,
              },
              {
                value: item.stable_retirement_result[0]?.attributes.gbey,
                key: this.$t('products.annuity.ar_guranteedBreakevenYear'),
                topSubText: '',
                toolTipHtml: '',
                symbolValue: '',
                originalValue: '',
                isTextBlack: true,
              }
            ]
          };
        } else if (this.filter.objectiveValue?.value === 'growth_retirement_income') {
          mConditionalResult = {
            showFiveStarBadge: item.overall_star_growth_retirement,
            keyItems: [
              {
                value: this.$formatPrice(item.g_initial_annual_income_growth_retirement),
                key: this.$t('products.annuity.ar_guaranteedInitialAnnualIncome'),
                topSubText: item.currency_code,
                toolTipHtml: '',
                symbolValue: '',
                originalValue: ''
              },
              {
                value: this.$formatPercentageDP(item.growth_retirement_result[0]?.attributes.g_return_ratio, 1),
                key: this.getGuaranteedIncomeText,
                topSubText: '',
                toolTipHtml: this.filter?.incomeTermValue[this.filter?.objectiveValue?.value]?.value === '10' ? this.getTooltipContentByKey('ar_guaranteedReturnRatioatAge75') : this.getTooltipContentByKey('ar_guaranteedReturnRatioatAge85'),
                symbolValue: '',
                originalValue: '',
                isTextBlack: true,
              },
              {
                value: this.$formatPercentageDP(item.growth_retirement_result[0]?.attributes?.p_return_ratio, 1),
                key: this.getProjectedIncomeText,
                topSubText: '',
                toolTipHtml: this.filter?.incomeTermValue[this.filter?.objectiveValue?.value]?.value === '10' ? this.getTooltipContentByKey('ar_projectedReturnRatioatAge75') : this.getTooltipContentByKey('ar_projectedReturnRatioatAge85'),
                symbolValue: '',
                originalValue: '',
                isTextBlack: true,
              },
              {
                value: item.growth_retirement_result[0]?.attributes.gbey,
                key: this.$t('products.annuity.ar_guranteedBreakevenYear'),
                topSubText: '',
                toolTipHtml: '',
                symbolValue: '',
                originalValue: '',
                isTextBlack: true,
              }
            ],
            mobileKeyItems: [
              {
                value: this.$formatPrice(item.g_initial_annual_income_growth_retirement),
                key: this.$t('products.annuity.ar_guaranteedInitialAnnualIncome'),
                topSubText: item.currency_code,
                toolTipHtml: '',
                symbolValue: '',
                originalValue: '',
                isTextBold: true,
              },
              {
                value: this.$formatPercentageDP(item.growth_retirement_result[0]?.attributes.g_return_ratio, 1),
                key:this.getGuaranteedIncomeText,
                topSubText: '',
                toolTipHtml: this.filter?.incomeTermValue[this.filter?.objectiveValue?.value]?.value === '10' ? this.getTooltipContentByKey('ar_guaranteedReturnRatioatAge75') : this.getTooltipContentByKey('ar_guaranteedReturnRatioatAge85'),
                symbolValue: '',
                originalValue: '',
                isTextBlack: true,
              },
              {
                value: this.$formatPercentageDP(item.growth_retirement_result[0]?.attributes?.p_return_ratio, 1),
                key: this.getProjectedIncomeText,
                topSubText: '',
                toolTipHtml: this.filter?.incomeTermValue[this.filter?.objectiveValue?.value]?.value === '10' ? this.getTooltipContentByKey('ar_projectedReturnRatioAge75') : this.getTooltipContentByKey('ar_projectedReturnRatioatAge85'),
                symbolValue: '',
                originalValue: '',
                isTextBlack: true,
              },
              {
                value: item.growth_retirement_result[0]?.attributes.gbey,
                key: this.$t('products.annuity.ar_guranteedBreakevenYear'),
                topSubText: '',
                toolTipHtml: '',
                symbolValue: '',
                originalValue: '',
                isTextBlack: true,
              }
            ],
            compactKeyItems: [
              {
                value: this.$formatPercentageDP(item.growth_retirement_result[0]?.attributes.g_return_ratio, 1),
                key: this.getGuaranteedIncomeText,
                topSubText: '',
                toolTipHtml: this.filter?.incomeTermValue[this.filter?.objectiveValue?.value]?.value === '10' ? this.getTooltipContentByKey('ar_guaranteedReturnRatioatAge75') : this.getTooltipContentByKey('ar_guaranteedReturnRatioatAge85'),
                symbolValue: '',
                originalValue: '',
                isTextBlack: true,
              },
              {
                value: item.growth_retirement_result[0]?.attributes.gbey,
                key: this.$t('products.annuity.ar_guranteedBreakevenYear'),
                topSubText: '',
                toolTipHtml: '',
                symbolValue: '',
                originalValue: '',
                isTextBlack: true,
              }
            ]
          };
        } else if (this.filter.objectiveValue?.value === 'longevity') {
          mConditionalResult = {
            showFiveStarBadge: item.overall_star_longevity,
            keyItems: [
              {
                value: this.$formatPrice(item.g_initial_annual_income_longevity),
                key: this.$t('products.annuity.al_guaranteedInitialAnnualIncome'),
                topSubText: item.currency_code,
                toolTipHtml: '',
                symbolValue: '',
                originalValue: '',
                isTextBlack: false,
              },
              {
                value: this.$formatPercentageDP(item.longevity_100_result[0]?.attributes.g_return_ratio, 1),
                key: this.$t('products.annuity.al_guaranteedReturnRatioatAge100'),
                topSubText: '',
                toolTipHtml: this.getTooltipContentByKey('al_guaranteedReturnRatioatAge100'),
                symbolValue: '',
                originalValue: '',
                isTextBlack: true,
              },
              {
                value: this.$formatPercentageDP(item.longevity_100_result[0]?.attributes?.p_return_ratio, 1),
                key: this.$t('products.annuity.al_projectedReturnRatioatAge100'),
                topSubText: '',
                toolTipHtml: this.getTooltipContentByKey('al_projectedReturnRatioatAge100'),
                symbolValue: '',
                originalValue: '',
                isTextBlack: true,
              },
              {
                value: item.longevity_result[0]?.attributes.gbey,
                key: this.$t('products.annuity.al_guaranteedAnnuityBreakevenYear'),
                topSubText: '',
                toolTipHtml: '',
                symbolValue: '',
                originalValue: '',
                isTextBlack: false,
              }
            ],
            mobileKeyItems: [
              {
                value: this.$formatPrice(item.g_initial_annual_income_longevity),
                key: this.$t('products.annuity.al_guaranteedInitialAnnualIncome'),
                topSubText: item.currency_code,
                toolTipHtml: '',
                symbolValue: '',
                originalValue: '',
                isTextBlack: false,
                isTextBold: true,
              },
              {
                value: this.$formatPercentageDP(item.longevity_100_result[0]?.attributes?.g_return_ratio, 1),
                key: this.$t('products.annuity.al_guaranteedReturnRatioatAge100'),
                topSubText: '',
                toolTipHtml: this.getTooltipContentByKey('al_guaranteedReturnRatioatAge100'),
                symbolValue: '',
                originalValue: '',
                isTextBlack: true,
              },
              {
                value: this.$formatPercentageDP(item.longevity_100_result[0]?.attributes?.p_return_ratio, 1),
                key: this.$t('products.annuity.al_projectedReturnRatioatAge100'),
                topSubText: '',
                toolTipHtml: this.getTooltipContentByKey('al_projectedReturnRatioatAge100'),
                symbolValue: '',
                originalValue: '',
                isTextBlack: true,
              },
              {
                value: item.longevity_result[0]?.attributes.gbey,
                key: this.$t('products.annuity.al_guaranteedAnnuityBreakevenYear'),
                topSubText: '',
                toolTipHtml: '',
                symbolValue: '',
                originalValue: '',
                isTextBlack: false,
              }
            ],
            compactKeyItems: [
              {
                value: this.$formatPrice(item.g_initial_annual_income_longevity),
                key: this.$t('products.annuity.al_guaranteedInitialAnnualIncome'),
                topSubText: '',
                toolTipHtml: '',
                symbolValue: '',
                originalValue: '',
                isTextBlack: true,
              },
              {
                value: item.longevity_result[0]?.attributes.gbey,
                key: this.$t('products.annuity.al_guaranteedAnnuityBreakevenYear'),
                topSubText: '',
                toolTipHtml: '',
                symbolValue: '',
                originalValue: '',
                isTextBlack: false,
              }
            ]
          };
        }

        return {
          id: item.scenario_code,
          category: this.category,
          scenarioId: item.scenarioID,
          showFiveStarBadge: mConditionalResult.showFiveStarBadge,
          showTrending: false,
          productLink: this.$extendPath(this.$route.path, this.filter.objectiveValue?.value + '/' + item.scenario_code),
          productName: item.plan_name,
          insuranceCompany: {
            name: item.insurer_name_first + ' | ' + item.insurer_name_second,
            code: item.insurer_code,
            logoSrc: item.insurer_logo?.data?.attributes.url,
            logoAlt: item.insurer_name_en
          },
          userRating: {
            score: this.getScore(this.filter, item),
            numberOfRatedUser: '0'
          },
          tenlifeScore: {
            score: parseFloat(this.getScore(this.filter, item)),
            description: this.getScoreLabel(this.filter),
            toolTipHtml: this.getScoreTooltip()
          },
          features: [
            {
              text: item.premium_term + this.$t('products.yearPremium'),
              type: 'payment_term'
            },
            {
              text:
                this.$formatAge(this.currentLocale, item.income_term_start, this.$t('products.ageUnit')) +
                this.$t('products.annuity.as_annuityStart'),
              type: 'annuity_start_age'
            },
            {
              text:
                item.income_term === 999
                  ? this.$t('products.annuity.ai_wholelife')
                  : item.income_term + this.$t('products.yearAnnuity'),
              type: 'income_term'
            }
          ],
          keyItems: mConditionalResult.keyItems,
          compactKeyItems: mConditionalResult.compactKeyItems,
          mobileKeyItems: mConditionalResult.mobileKeyItems,
          promotion: {
            category:
              item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes
                ?.PromotionCategory,
            title:
              item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.PromotionTitle,
            ctaButtonLink:
              item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.CTAButtonLink,
            ctaButtonText:
              item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.CTAButtonText,
            promotionId: item.product_promotion?.id,
            scenarioId: item.scenarioID,
            lastCall: item.promotion_last_call

          },
          mainButtonCTA: item.main_cta,
          showShortcutFulfilmentRatio: item.shortcutfilfulmentRatio,
        };
      });
    },

    // incomeTermOptionsObjective() {
    //   if (this.filter.objectiveValue?.value == 'longevity') {
    //     return [
    //       { value: '-1', text: this.$t('products.any') },
    //       { value: '20', text: '20 ' + this.$t('products.yearsUnit') },
    //       { value: '20+', text: this.$t('products.annuity.twenty_years_above')  }
    //     ]
    //   }

    //   return [
    //       { value: '-1', text: this.$t('products.any') },
    //       { value: '10', text: '10 ' + this.$t('products.yearsUnit') },
    //       { value: '20', text: '20 ' + this.$t('products.yearsUnit') },
    //       { value: '20+', text: this.$t('products.annuity.twenty_years_above')  }
    //     ]
    // },

    rows() {
      if (this.simpleItems) {
        return this.simpleItems.length;
      }
      return 0;
    },

    testSortedItem () {
      if (this.filter.objectiveValue?.value === 'stable_retirement_income') {
              return this.simpleItems
                .map((item) => item)
                .sort(
                  (a, b) =>
                    (b.overall_star_stable_retirement) - (a.overall_star_stable_retirement) ||
                    b.stable_retirement_result[0]?.attributes.stable_retirement_total_overall_score - a.stable_retirement_result[0]?.attributes.stable_retirement_total_overall_score ||
                    b.g_initial_annual_income_stable_retirement - a.g_initial_annual_income_stable_retirement ||
                    b.stable_retirement_result[0]?.attributes.g_return_ratio -
                      a.stable_retirement_result[0]?.attributes.g_return_ratio ||
                    b.stable_retirement_result[0]?.attributes.p_return_ratio -
                      a.stable_retirement_result[0]?.attributes.p_return_ratio
                );}
    },

    sortedItem() {
      try {
        if (this.sortingData.sortValue.value === 'five_star') {
          if (this.simpleItems) {
            if (this.filter.objectiveValue?.value === 'savings') {
              return this.simpleItems
                .map((item) => item)
                .sort(
                  (a, b) =>
                    (b.overall_star_savings) - (a.overall_star_savings) ||
                    b.savings_result[0]?.attributes.savings_total_overall_score - a.savings_result[0]?.attributes.savings_total_overall_score ||
                    b.g_initial_annual_income_savings - a.g_initial_annual_income_savings ||
                    b.savings_result[0]?.attributes.g_return_ratio -
                      a.savings_result[0]?.attributes.g_return_ratio ||
                    b.savings_result[0]?.attributes.p_return_ratio -
                      a.savings_result[0]?.attributes.p_return_ratio
                );
            } else if (this.filter.objectiveValue?.value === 'stable_retirement_income') {
              return this.simpleItems
                .map((item) => item)
                .sort(
                  (a, b) =>
                    (b.overall_star_stable_retirement) - (a.overall_star_stable_retirement) ||
                    b.stable_retirement_result[0]?.attributes.stable_retirement_total_overall_score - a.stable_retirement_result[0]?.attributes.stable_retirement_total_overall_score||
                    b.g_initial_annual_income_stable_retirement - a.g_initial_annual_income_stable_retirement ||
                    b.stable_retirement_result[0]?.attributes.g_return_ratio -
                      a.stable_retirement_result[0]?.attributes.g_return_ratio ||
                    b.stable_retirement_result[0]?.attributes.p_return_ratio -
                      a.stable_retirement_result[0]?.attributes.p_return_ratio
                );
            } else if (this.filter.objectiveValue?.value === 'growth_retirement_income') {
              return this.simpleItems
                .map((item) => item)
                .sort(
                  (a, b) =>
                    (b.overall_star_growth_retirement) - (a.overall_star_growth_retirement) ||
                    b.growth_retirement_result[0]?.attributes.growth_retirement_total_overall_score - a.growth_retirement_result[0]?.attributes.growth_retirement_total_overall_score ||
                    b.g_initial_annual_income_growth_retirement - a.g_initial_annual_income_growth_retirement ||
                    b.growth_retirement_result[0]?.attributes.g_return_ratio -
                      a.growth_retirement_result[0]?.attributes.g_return_ratio ||
                    b.growth_retirement_result[0]?.attributes.p_return_ratio -
                      a.growth_retirement_result[0]?.attributes.p_return_ratio
                );
            } else {
              return this.simpleItems
                .map((item) => item)
                .sort(
                  (a, b) =>
                    (b.overall_star_longevity) - (a.overall_star_longevity) ||
                    b.longevity_result[0]?.attributes.longevity_total_overall_score - a.longevity_result[0]?.attributes.longevity_total_overall_score ||
                    b.g_initial_annual_income_longevity - a.g_initial_annual_income_longevity ||
                    b.longevity_result[0]?.attributes.g_return_ratio -
                      a.longevity_result[0]?.attributes.g_return_ratio ||
                    b.longevity_result[0]?.attributes.p_return_ratio -
                      a.longevity_result[0]?.attributes.p_return_ratio
                );
            }
          }
        } 
         else if (this.sortingData.sortValue.value === 'score') {
          if (this.simpleItems) {
            if (this.filter.objectiveValue?.value === 'savings') {
              return this.simpleItems
                .map((item) => item)
                .sort(
                  (a, b) =>
                  b.savings_result[0]?.attributes.savings_total_overall_score - a.savings_result[0]?.attributes.savings_total_overall_score ||
                  (b.overall_star_savings) - (a.overall_star_savings) ||
                  b.g_initial_annual_income_savings - a.g_initial_annual_income_savings ||
                    b.savings_result[0]?.attributes.g_return_ratio -
                      a.savings_result[0]?.attributes.g_return_ratio ||
                    b.savings_result[0]?.attributes.p_return_ratio -
                      a.savings_result[0]?.attributes.p_return_ratio
                );
            } else if (this.filter.objectiveValue?.value === 'stable_retirement_income') {
              return this.simpleItems
                .map((item) => item)
                .sort(
                  (a, b) =>
                  b.stable_retirement_result[0]?.attributes.stable_retirement_total_overall_score - a.stable_retirement_result[0]?.attributes.stable_retirement_total_overall_score ||
                  (b.overall_star_stable_retirement) - (a.overall_star_stable_retirement) ||
                    b.g_initial_annual_income_stable_retirement - a.g_initial_annual_income_stable_retirement ||
                    b.stable_retirement_result[0]?.attributes.g_return_ratio -
                      a.stable_retirement_result[0]?.attributes.g_return_ratio ||
                    b.stable_retirement_result[0]?.attributes.p_return_ratio -
                      a.stable_retirement_result[0]?.attributes.p_return_ratio
                );
            } else if (this.filter.objectiveValue?.value === 'growth_retirement_income') {
              return this.simpleItems
                .map((item) => item)
                .sort(
                  (a, b) =>
                  b.growth_retirement_result[0]?.attributes.growth_retirement_total_overall_score - a.growth_retirement_result[0]?.attributes.growth_retirement_total_overall_score ||
                  (b.overall_star_growth_retirement) - (a.overall_star_growth_retirement) ||
                    b.g_initial_annual_income_growth_retirement - a.g_initial_annual_income_growth_retirement ||
                    b.growth_retirement_result[0]?.attributes.g_return_ratio -
                      a.growth_retirement_result[0]?.attributes.g_return_ratio ||
                    b.growth_retirement_result[0]?.attributes.p_return_ratio -
                      a.growth_retirement_result[0]?.attributes.p_return_ratio
                );
            } else {
              return this.simpleItems
                .map((item) => item)
                .sort(
                  (a, b) =>
                  b.longevity_result[0]?.attributes.longevity_total_overall_score - a.longevity_result[0]?.attributes.longevity_total_overall_score ||
                  (b.overall_star_longevity) - (a.overall_star_longevity) ||
                    b.g_initial_annual_income_longevity - a.g_initial_annual_income_longevity ||
                    b.longevity_result[0]?.attributes.g_return_ratio -
                      a.longevity_result[0]?.attributes.g_return_ratio ||
                    b.longevity_result[0]?.attributes.p_return_ratio -
                      a.longevity_result[0]?.attributes.p_return_ratio
                );
            }
          }
        } else if (this.sortingData.sortValue.value === 'g_annuity') {
          if (this.simpleItems) {
            if (this.filter.objectiveValue?.value === 'savings') {
              return this.simpleItems
                .map((item) => item)
                .sort(
                  (a, b) =>
                  b.g_initial_annual_income_savings - a.g_initial_annual_income_savings ||
                  (b.overall_star_savings) - (a.overall_star_savings) ||
                    b.savings_result[0]?.attributes.savings_total_overall_score - a.savings_result[0]?.attributes.savings_total_overall_score ||
                    b.savings_result[0]?.attributes.g_return_ratio -
                      a.savings_result[0]?.attributes.g_return_ratio ||
                    b.savings_result[0]?.attributes.p_return_ratio -
                      a.savings_result[0]?.attributes.p_return_ratio
                );
            } else if (this.filter.objectiveValue?.value === 'stable_retirement_income') {
              return this.simpleItems
                .map((item) => item)
                .sort(
                  (a, b) =>
                  b.g_initial_annual_income_stable_retirement - a.g_initial_annual_income_stable_retirement ||
                  (b.overall_star_stable_retirement) - (a.overall_star_stable_retirement) ||
                    b.stable_retirement_result[0]?.attributes.stable_retirement_total_overall_score - a.stable_retirement_result[0]?.attributes.stable_retirement_total_overall_score ||
                    b.stable_retirement_result[0]?.attributes.g_return_ratio -
                      a.stable_retirement_result[0]?.attributes.g_return_ratio ||
                    b.stable_retirement_result[0]?.attributes.p_return_ratio -
                      a.stable_retirement_result[0]?.attributes.p_return_ratio
                );
            } else if (this.filter.objectiveValue?.value === 'growth_retirement_income') {
              return this.simpleItems
                .map((item) => item)
                .sort(
                  (a, b) =>
                  b.g_initial_annual_income_growth_retirement - a.g_initial_annual_income_growth_retirement ||
                  (b.overall_star_growth_retirement) - (a.overall_star_growth_retirement) ||
                    b.growth_retirement_result[0]?.attributes.growth_retirement_total_overall_score - a.growth_retirement_result[0]?.attributes.growth_retirement_total_overall_score ||
                    b.growth_retirement_result[0]?.attributes.g_return_ratio -
                      a.growth_retirement_result[0]?.attributes.g_return_ratio ||
                    b.growth_retirement_result[0]?.attributes.p_return_ratio -
                      a.growth_retirement_result[0]?.attributes.p_return_ratio
                );
            } else {
              return this.simpleItems
                .map((item) => item)
                .sort(
                  (a, b) =>
                  b.g_initial_annual_income_longevity - a.g_initial_annual_income_longevity ||
                  (b.overall_star_longevity) - (a.overall_star_longevity) ||
                    b.longevity_result[0]?.attributes.longevity_total_overall_score - a.longevity_result[0]?.attributes.longevity_total_overall_score ||
                    b.longevity_result[0]?.attributes.g_return_ratio -
                      a.longevity_result[0]?.attributes.g_return_ratio ||
                    b.longevity_result[0]?.attributes.p_return_ratio -
                      a.longevity_result[0]?.attributes.p_return_ratio
                );
            }
          }
        } else if (this.sortingData.sortValue.value === 'g_irr') {
          if (this.simpleItems) {
            if (this.filter.objectiveValue?.value === 'savings') {
              return this.simpleItems
                .map((item) => item)
                .sort(
                  (a, b) =>
                  b.savings_result[0]?.attributes.g_return_ratio -
                    a.savings_result[0]?.attributes.g_return_ratio ||
                  (b.overall_star_savings) - (a.overall_star_savings) ||
                    b.savings_result[0]?.attributes.savings_total_overall_score - a.savings_result[0]?.attributes.savings_total_overall_score ||
                    b.g_initial_annual_income_savings - a.g_initial_annual_income_savings ||
                    b.savings_result[0]?.attributes.p_return_ratio -
                      a.savings_result[0]?.attributes.p_return_ratio
                );
            } else if (this.filter.objectiveValue?.value === 'stable_retirement_income') {
              return this.simpleItems
                .map((item) => item)
                .sort(
                  (a, b) =>
                  b.stable_retirement_result[0]?.attributes.g_return_ratio -
                    a.stable_retirement_result[0]?.attributes.g_return_ratio ||
                  (b.overall_star_stable_retirement) - (a.overall_star_stable_retirement) ||
                    b.stable_retirement_result[0]?.attributes.stable_retirement_total_overall_score - a.stable_retirement_result[0]?.attributes.stable_retirement_total_overall_score ||
                    b.g_initial_annual_income_stable_retirement - a.g_initial_annual_income_stable_retirement ||
                    b.stable_retirement_result[0]?.attributes.p_return_ratio -
                      a.stable_retirement_result[0]?.attributes.p_return_ratio
                );
            } else if (this.filter.objectiveValue?.value === 'growth_retirement_income') {
              return this.simpleItems
                .map((item) => item)
                .sort(
                  (a, b) =>
                  b.growth_retirement_result[0]?.attributes.g_return_ratio -
                    a.growth_retirement_result[0]?.attributes.g_return_ratio ||
                  (b.overall_star_growth_retirement) - (a.overall_star_growth_retirement) ||
                    b.growth_retirement_result[0]?.attributes.growth_retirement_total_overall_score - a.growth_retirement_result[0]?.attributes.growth_retirement_total_overall_score ||
                    b.g_initial_annual_income_growth_retirement - a.g_initial_annual_income_growth_retirement ||
                    b.growth_retirement_result[0]?.attributes.p_return_ratio -
                      a.growth_retirement_result[0]?.attributes.p_return_ratio
                );
            } else {
              return this.simpleItems
                .map((item) => item)
                .sort(
                  (a, b) =>
                  (b.overall_star_longevity) - (a.overall_star_longevity) ||
                    b.longevity_result[0]?.attributes.longevity_total_overall_score - a.longevity_result[0]?.attributes.longevity_total_overall_score ||
                    b.g_initial_annual_income_longevity - a.g_initial_annual_income_longevity ||
                    b.longevity_result[0]?.attributes.g_return_ratio -
                      a.longevity_result[0]?.attributes.g_return_ratio ||
                    b.longevity_result[0]?.attributes.p_return_ratio -
                      a.longevity_result[0]?.attributes.p_return_ratio
                );
            }
          }
        } else if(this.sortingData.sortValue.value === 'p_irr') {
          if (this.simpleItems) {
            if (this.filter.objectiveValue?.value === 'savings') {
              return this.simpleItems
                .map((item) => item)
                .sort(
                  (a, b) =>
                  b.savings_result[0]?.attributes.p_return_ratio -
                    a.savings_result[0]?.attributes.p_return_ratio ||
                  (b.overall_star_savings) - (a.overall_star_savings) ||
                    b.savings_result[0]?.attributes.savings_total_overall_score - a.savings_result[0]?.attributes.savings_total_overall_score ||
                    b.g_initial_annual_income_savings - a.g_initial_annual_income_savings ||
                    b.savings_result[0]?.attributes.g_return_ratio -
                      a.savings_result[0]?.attributes.g_return_ratio
                );
            } else if (this.filter.objectiveValue?.value === 'stable_retirement_income') {
              return this.simpleItems
                .map((item) => item)
                .sort(
                  (a, b) =>
                  b.stable_retirement_result[0]?.attributes.p_return_ratio -
                    a.stable_retirement_result[0]?.attributes.p_return_ratio ||
                  (b.overall_star_stable_retirement) - (a.overall_star_stable_retirement) ||
                    b.stable_retirement_result[0]?.attributes.stable_retirement_total_overall_score - a.stable_retirement_result[0]?.attributes.stable_retirement_total_overall_score ||
                    b.g_initial_annual_income_stable_retirement - a.g_initial_annual_income_stable_retirement ||
                    b.stable_retirement_result[0]?.attributes.g_return_ratio -
                      a.stable_retirement_result[0]?.attributes.g_return_ratio
                );
            } else if (this.filter.objectiveValue?.value === 'growth_retirement_income') {
              return this.simpleItems
                .map((item) => item)
                .sort(
                  (a, b) =>
                  b.growth_retirement_result[0]?.attributes.p_return_ratio -
                    a.growth_retirement_result[0]?.attributes.p_return_ratio ||
                  (b.overall_star_growth_retirement) - (a.overall_star_growth_retirement) ||
                    b.growth_retirement_result[0]?.attributes.growth_retirement_total_overall_score - a.growth_retirement_result[0]?.attributes.growth_retirement_total_overall_score ||
                    b.g_initial_annual_income_growth_retirement - a.g_initial_annual_income_growth_retirement ||
                    b.growth_retirement_result[0]?.attributes.g_return_ratio -
                      a.growth_retirement_result[0]?.attributes.g_return_ratio
                );
            } else {
              return this.simpleItems
                .map((item) => item)
                .sort(
                  (a, b) =>
                  b.longevity_result[0]?.attributes.p_return_ratio -
                    a.longevity_result[0]?.attributes.p_return_ratio ||
                  b.longevity_result[0]?.attributes.longevity_total_overall_score - a.longevity_result[0]?.attributes.longevity_total_overall_score ||
                  (b.overall_star_longevity) - (a.overall_star_longevity) ||
                    b.g_initial_annual_income_longevity - a.g_initial_annual_income_longevity ||
                    b.longevity_result[0]?.attributes.g_return_ratio -
                      a.longevity_result[0]?.attributes.g_return_ratio
                );
            }
          }
        } else if (this.sortingData.sortValue.value === 'g_bey') {
          if (this.simpleItems) {
            if (this.filter.objectiveValue?.value === 'savings') {
              return this.simpleItems
                .map((item) => item)
                .sort(
                  (a, b) =>
                    a.savings_result[0]?.attributes.gbey - b.savings_result[0]?.attributes.gbey ||
                    (b.overall_star_savings) - (a.overall_star_savings) ||
                    b.savings_result[0]?.attributes.savings_total_overall_score - a.savings_result[0]?.attributes.savings_total_overall_score ||
                    b.g_initial_annual_income_savings - a.g_initial_annual_income_savings ||
                    b.savings_result[0]?.attributes.g_return_ratio -
                      a.savings_result[0]?.attributes.g_return_ratio ||
                    b.savings_result[0]?.attributes.p_return_ratio -
                      a.savings_result[0]?.attributes.p_return_ratio
                );
            } else if (this.filter.objectiveValue?.value === 'stable_retirement_income') {
              return this.simpleItems
                .map((item) => item)
                .sort(
                  (a, b) =>
                    a.stable_retirement_result[0]?.attributes.gbey - b.stable_retirement_result[0]?.attributes.gbey ||
                    (b.overall_star_stable_retirement) - (a.overall_star_stable_retirement) ||
                    b.stable_retirement_result[0]?.attributes.stable_retirement_total_overall_score - a.stable_retirement_result[0]?.attributes.stable_retirement_total_overall_score ||
                    b.g_initial_annual_income_stable_retirement - a.g_initial_annual_income_stable_retirement ||
                    b.stable_retirement_result[0]?.attributes.g_return_ratio -
                      a.stable_retirement_result[0]?.attributes.g_return_ratio ||
                    b.stable_retirement_result[0]?.attributes.p_return_ratio -
                      a.stable_retirement_result[0]?.attributes.p_return_ratio
                );
            } else if (this.filter.objectiveValue?.value === 'growth_retirement_income') {
              return this.simpleItems
                .map((item) => item)
                .sort(
                  (a, b) =>
                    a.growth_retirement_result[0]?.attributes.gbey - b.growth_retirement_result[0]?.attributes.gbey ||
                    (b.overall_star_growth_retirement) - (a.overall_star_growth_retirement) ||
                    b.growth_retirement_result[0]?.attributes.growth_retirement_total_overall_score - a.growth_retirement_result[0]?.attributes.growth_retirement_total_overall_score ||
                    b.g_initial_annual_income_growth_retirement - a.g_initial_annual_income_growth_retirement ||
                    b.growth_retirement_result[0]?.attributes.g_return_ratio -
                      a.growth_retirement_result[0]?.attributes.g_return_ratio ||
                    b.growth_retirement_result[0]?.attributes.p_return_ratio -
                      a.growth_retirement_result[0]?.attributes.p_return_ratio
                );
            } else {
              return this.simpleItems
                .map((item) => item)
                .sort(
                  (a, b) =>
                  a.longevity_result[0]?.attributes.gbey - b.longevity_result[0]?.attributes.gbey ||
                  (b.overall_star_longevity) - (a.overall_star_longevity) ||
                    b.longevity_result[0]?.attributes.longevity_total_overall_score - a.longevity_result[0]?.attributes.longevity_total_overall_score ||
                    b.g_initial_annual_income_longevity - a.g_initial_annual_income_longevity ||
                    b.longevity_result[0]?.attributes.g_return_ratio -
                      a.longevity_result[0]?.attributes.g_return_ratio ||
                    b.longevity_result[0]?.attributes.p_return_ratio -
                      a.longevity_result[0]?.attributes.p_return_ratio
                );
            }
          }
        }
        return null;
      } catch {
        return null;
      }
    },

    simpleItems() {
      if (this.annuityPlanScenarios) {
        return this.annuityPlanScenarios.data.map((item) => {
          let promotions = null;
          let promotion = null;
          let promotion_last_call = null;

          const planName =
            item.attributes.annuity_plan.data.attributes.annuity_plan_translations.data[0].attributes.name;
          let decoderCTALink = '';

          let mainCTA = this.getDecoderCTA(item, decoderCTALink);

          // check scenario level promo first , then plan level promotion
          if (item.attributes.product_promotions.data?.length > 0) {
            promotions = item.attributes.product_promotions.data;
          }
          if (item.attributes.annuity_plan.data.attributes.product_promotions.data?.length > 0) {
            promotions = item.attributes.annuity_plan.data.attributes.product_promotions.data;
          }

          if (promotions != null) {
            promotion = this.checkPromotionValid(promotions);
            promotion_last_call = this.checkPromotionLastCall(promotion);

            if (!promotion) {
              promotion = null;
            } else if (promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink) {
              decoderCTALink =
                promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink;

              mainCTA = this.getDecoderCTA(item, decoderCTALink);
            }
          }
          const getFulfilmentShortcut = this.getAnnuityFulfilmentShortcut(item.attributes);
          const shortcutfilfulmentRatio = getFulfilmentShortcut.fulfilmentRatio;

          const filteredTranslations = this.getFilteredTranslations(item.attributes.annuity_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
          .insurance_company_translations.data[0].attributes.localizations.data);
          

          const savings_result = item.attributes.annuity_plan_financial_details.data.filter(
              (item) => item.attributes.age === 60
            );
          

          const stable_retirement_result = item.attributes.annuity_plan_financial_details.data.filter(
              (fd) => {
                if (item.attributes.income_term_end < 85 && item.attributes.income_term_end !== -1) {
                  const ageForFilter = parseFloat(this.filter?.startAgeValue[this.filter?.objectiveValue?.value]?.value) + parseFloat(this.filter?.incomeTermValue[this.filter?.objectiveValue?.value]?.value)
                  return fd.attributes.age === ageForFilter;
                  // return fd.attributes.age === item.attributes.income_term_end;
                }
                return fd.attributes.age === 85;
              }
            )  

          const growth_retirement_result = item.attributes.annuity_plan_financial_details.data.filter(
              (fd) => {
                if (item.attributes.income_term_end < 85 && item.attributes.income_term_end !== -1) {
                  const ageForFilter = parseFloat(this.filter?.startAgeValue[this.filter?.objectiveValue?.value]?.value) + parseFloat(this.filter?.incomeTermValue[this.filter?.objectiveValue?.value]?.value)
                  return fd.attributes.age === ageForFilter;
                  // return fd.attributes.age === item.attributes.income_term_end;
                }
                return fd.attributes.age === 85;
              }
            )
          const longevity_result = item.attributes.annuity_plan_financial_details.data.filter(
              (fd) => {
                  if (item.attributes.income_term_end < 105 && item.attributes.income_term_end !== -1) {
                    return fd.attributes.age === item.attributes.income_term_end;
                  }
                  return fd.attributes.age === 105;
                }
            )
          const longevity_100_result = item.attributes.annuity_plan_financial_details.data.filter(
              (fd) => {
                return fd.attributes.age === 100;
              }
            );
          return {
            plan_code: item.attributes.annuity_plan.data.attributes.plan_code,
            scenario_code: item.attributes.scenario_code,
            premium_term: item.attributes.premium_term,
            income_term_start: item.attributes.income_term_start,
            income_term: item.attributes.income_term,
            // overall_star_savings: item.attributes.overall_star_savings,
            // overall_star_retirement: item.attributes.overall_star_retirement,
            // overall_star_longevity: item.attributes.overall_star_longevity,
            gbey: item.attributes.gbey,
            currency_code: item.attributes.currency.data.attributes.code,

            // annuity_longevity_score: item.attributes.annuity_longevity_score.toFixed(1),
            // annuity_retirement_score: item.attributes.annuity_retirement_score.toFixed(1),
            // annuity_savings_score: item.attributes.annuity_savings_score.toFixed(1),
            shortcutfilfulmentRatio,



            // // plan
            plan_name: planName,
            // // insurer
            insurer_name_first:
              item.attributes.annuity_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
                .insurance_company_translations.data[0].attributes.name,
            insurer_name_second:
              filteredTranslations[0].attributes.name,
            insurer_logo:
              item.attributes.annuity_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
                .logo,
            insurer_code:
              item.attributes.annuity_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
                .code,
            insurer_ifs: item.attributes.annuity_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.saving_input_insurer_ifs.data.attributes,
            insurer_fr_details: item.attributes.annuity_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.saving_input_insurer_ifs.data.attributes,

            // // financial details
            savings_result,
            stable_retirement_result,
            longevity_result,
            longevity_100_result,
            growth_retirement_result,
            first_income_result: item.attributes.annuity_plan_financial_details.data.filter(
              (e) => e.attributes.age === item.attributes.income_term_start
            ),
            product_promotion: promotion,
            promotion_last_call: promotion_last_call,

            scenarioID: item.id,

            main_cta: mainCTA,

            overall_star_savings: savings_result[0]?.attributes?.overall_star_savings,
            overall_star_stable_retirement: stable_retirement_result[0]?.attributes?.overall_star_stable_retirement,
            overall_star_growth_retirement:  growth_retirement_result[0]?.attributes?.overall_star_growth_retirement,
            overall_star_longevity: longevity_result[0]?.attributes?.overall_star_longevity,

            // Convert in to function
            g_initial_annual_income_savings: (savings_result[0]?.attributes?.initial_income_gcv / savings_result[0]?.attributes?.discounted_tpp)*item?.attributes.tpp_display ,
            // g_initial_annual_income_stable_retirement: stable_retirement_result[0]?.attributes?.income_gcv ,
            g_initial_annual_income_stable_retirement: (stable_retirement_result[0]?.attributes?.initial_income_gcv / stable_retirement_result[0]?.attributes?.discounted_tpp)*item?.attributes.tpp_display ,
            g_initial_annual_income_growth_retirement: (growth_retirement_result[0]?.attributes?.initial_income_gcv / growth_retirement_result[0]?.attributes?.discounted_tpp)*item?.attributes.tpp_display ,
            g_initial_annual_income_longevity: (longevity_result[0]?.attributes?.initial_income_gcv / longevity_result[0]?.attributes?.discounted_tpp)*item?.attributes.tpp_display ,
          };
        });
      }
      return null;
    },

    sortingOptions() {
      return [
        
        { value: 'five_star', text: this.$t('products.annuity.as_5StarRatings') },
        { value: 'score', text: this.getScoreLabel(this.filter) },
        { value: 'g_annuity', text: this.$t('products.annuity.as_guaranteedInitialAnnualIncomeHightoLow') },
        { value: 'g_irr', text: this.getGIRRLabel(this.filter) },
        { value: 'p_irr', text: this.getPIRRLabel(this.filter) },
        { value: 'g_bey', text: this.$t('products.annuity.as_guaranteedBreakevenYearShorttoLong') }
      ];
    },

    issueAgeDefaultValue() {
      return this.filter?.objectiveValue?.value === 'savings' ? '35' : '35';
    },

    startAgeDefaultValue() {
      return this.filter?.objectiveValue?.value === 'savings' ? '50' : this.filter?.objectiveValue?.value.includes('retirement_income') ? '65' : '60';
    },

    premiumTermDefaultValue() {
      return this.filter?.objectiveValue?.value === 'savings' ? '5' : '10';
    },

    incomeTermDefaultValue() {

      if (this.filter?.objectiveValue?.value === 'savings' || this.filter?.objectiveValue?.value === 'stable_retirement_income') {
        return '10';
      } else if (this.filter?.objectiveValue?.value === 'growth_retirement_income') {
        return '20';
      } else if (this.filter?.objectiveValue?.value === 'longevity') {
        return '20+';
      }
      return '-1';
      // return this.filter?.objectiveValue?.value === 'savings' || this.filter?.objectiveValue?.value.includes('retirement_income') ? '10' : this.filter?.objectiveValue?.value === 'longevity' ? '20+' : '-1';
    },

    objectiveValue() {
      return this.filter.objectiveValue.value;
    },

    filterIssueAgeActualValue() {
      return this.filter.issueAgeValue[this.filter.objectiveValue?.value];
    },

    filterIssueAgeOptions() {
      return this.filter.issueAgeOptions[this.filter.objectiveValue?.value];
    },

    filterStartAgeActualValue() {
      return this.filter.startAgeValue[this.filter.objectiveValue?.value];
    },

    filterStartAgeOptions() {
      return this.filter.startAgeOptions[this.filter.objectiveValue?.value];
    },

    filterPremiumTermActualValue() {
      return this.filter.premiumTermValue[this.filter.objectiveValue?.value];
    },

    filterPremiumTermOptions() {
      return this.premiumTermOptions;
    },

    filterCurrencyValue() {
      return this.filter.currencyValue[this.filter.objectiveValue?.value];
    },

    filterCurrencyOptions() {
      return this.filter.currencyOptions[this.filter.objectiveValue?.value];
    },

    filterIncomeTermActualValue() {
      return this.filter.incomeTermValue[this.filter.objectiveValue?.value];
    },

    filterIncomeTermOptions() {
      return this.incomeTermOptions;
    },

    dependentFilterValues() {
      // console.log('*** dependentFilterValues ***');
      // console.log('objective value -- ', this.objectiveValue);
      // console.log('issue age value -- ', this.filterIssueAgeActualValue.value);
      // console.log('start age value -- ', this.filterStartAgeActualValue.value);
      // console.log('premium term value -- ', this.filterPremiumTermActualValue.value);
      // console.log('currency value --', this.filterCurrencyValue.value);
      return `${this.objectiveValue}|${this.filterIssueAgeActualValue.value}|${this.filterStartAgeActualValue.value}|${this.filterPremiumTermActualValue.value}|${this.filterCurrencyValue.value}|${this.filterIncomeTermActualValue.value}`;
    },
    slug() {
      return 'qdap';
    },
    selectedSortingLogic() {
      return this.sortingData.sortValue.value
    },
    getGuaranteedIncomeText() {
      if (this.filter?.incomeTermValue[this.filter?.objectiveValue?.value]?.value === '10' || this.filter?.incomeTermValue[this.filter?.objectiveValue?.value]?.value === '20') {
        const age = parseFloat(this.filter?.startAgeValue[this.filter?.objectiveValue?.value]?.value) + parseFloat(this.filter?.incomeTermValue[this.filter?.objectiveValue?.value]?.value);
        return this.$t('products.annuity.ar_guaranteedReturnRatioatAge').replace('$num', age);
      }
      return this.$t('products.annuity.ar_guaranteedReturnRatioatAge85');
    },
    getProjectedIncomeText() {
      if (this.filter?.incomeTermValue[this.filter?.objectiveValue?.value]?.value === '10' || this.filter?.incomeTermValue[this.filter?.objectiveValue?.value]?.value === '20') {
        const age = parseFloat(this.filter?.startAgeValue[this.filter?.objectiveValue?.value]?.value) + parseFloat(this.filter?.incomeTermValue[this.filter?.objectiveValue?.value]?.value);
        return this.$t('products.annuity.ar_projectedReturnRatioatAge').replace('$num', age);
      }
      return this.$t('products.annuity.ar_guaranteedReturnRatioatAge85');
    },
  },

  watch: {
    objectiveValue: {
      handler(newVal) {
        this.category = /[^/]*$/.exec(this.$route.path)[0] + '/' + newVal;
      }
    },

    dependentFilterValues: {
      handler() {
        this.updateDependentFilterQuerystrings();
      }
    }
  },

  created() {
    const filterValuesToWatch = [
      {
        filterValuePath: 'sortingData.sortValue',
        filterOptionsPath: 'sortingOptions',
        queryKey: 'sort',
        defaultValue: 'five_star',
        ignoreFix: true
      },
      {
        filterValuePath: 'filter.insCompValue',
        filterOptionsPath: 'insuranceCompanies',
        queryKey: 'ins_comp[]',
        defaultValue: [],
        ignoreFix: true,
        type: 'array'
      },
      {
        filterValuePath: 'filter.selectionSelected',
        queryKey: 'advisorAssistance',
        defaultValue: true,
        ignoreFix: true,
        type: 'checkbox',
      },
    ];

    this.createFilterWatchers(filterValuesToWatch);
    this.fixFilterValues(filterValuesToWatch);

    const fixSortingValue = () => {
      const actualValue = this.$_.get(this, 'sortingData.sortValue.value');
      this.updateSortingValue(actualValue);
    };

    const fixObjectiveValue = () => {
      const actualValue = this.$_.get(this, 'filter.objectiveValue.value');
      this.updateObjectiveValue(actualValue);
    };
    fixObjectiveValue();

    this.$watch(
      '$route.query.' + 'objective',
      (newValue) => {
        const mValue = newValue === undefined || newValue === null ? 'savings' : newValue;
        this.updateObjectiveValue(mValue);

        // since sortingOptions have dependency with objectiveValue, fix sorting value here
        fixSortingValue();
      },
      { immediate: true }
    );

    const fixStartAgeValue = () => {
      const actualValue = this.$_.get(this, 'filterStartAgeActualValue' + '.value');
      this.updateStartAgeValue(actualValue);
    };
    fixStartAgeValue();

    this.$watch(
      '$route.query.' + 'start_age',
      (newValue) => {
        if (newValue === undefined) {
          return;
        }

        const mValue = newValue === undefined || newValue === null ? this.startAgeDefaultValue : newValue;
        this.updateStartAgeValue(mValue);
      },
      { immediate: true }
    );

    const fixIssueAgeValue = () => {
      const actualValue = this.$_.get(this, 'filterIssueAgeActualValue' + '.value');
      this.updateIssueAgeValue(actualValue);
    };
    fixIssueAgeValue();

    this.$watch(
      '$route.query.' + 'issue_age',
      (newValue) => {
        if (newValue === undefined) {
          return;
        }

        const mValue = newValue === undefined || newValue === null ? this.issueAgeDefaultValue : newValue;
        this.updateIssueAgeValue(mValue);
      },
      { immediate: true }
    );

    const fixPremiumTermValue = () => {
      const actualValue = this.$_.get(this, 'filterPremiumTermActualValue' + '.value');
      this.updatePremiumTermValue(actualValue);
    };
    fixPremiumTermValue();

    this.$watch(
      '$route.query.' + 'premium_term',
      (newValue) => {
        if (newValue === undefined) {
          return;
        }

        const mValue = newValue === undefined || newValue === null ? this.premiumTermDefaultValue : newValue;
        this.updatePremiumTermValue(mValue);
      },
      { immediate: true }
    );

    const fixCurrencyValue = () => {
      const actualValue = this.$_.get(this, 'filterCurrencyValue' + '.value');
      this.updateCurrencyValue(actualValue);
    };
    fixCurrencyValue();

    this.$watch(
      '$route.query.' + 'currency',
      (newValue) => {
        if (newValue === undefined) {
          return;
        }

        const mValue = newValue === undefined || newValue === null ? '1' : newValue;
        this.updateCurrencyValue(mValue);
      },
      { immediate: true }
    );

    const fixIncomeTermValue = () => {
      const actualValue = this.$_.get(this, 'filterIncomeTermValue' + '.value');
      this.updateIncomeTermValue(actualValue);
    };
    fixIncomeTermValue();

    this.$watch(
      '$route.query.' + 'income_term',
      (newValue) => {
        if(newValue === undefined) {
          return;
        }

        const mValue = newValue === undefined || newValue === null ? this.incomeTermDefaultValue : newValue;
        this.updateIncomeTermValue(mValue);
      },
      { immediate: true }
    );
  },

  mounted() {
    // console.log('displayproducts', this.displayProducts)
    const filterValuesToFix = [
      {
        filterValuePath: 'sortingData.sortValue',
        filterOptionsPath: 'sortingOptions',
        queryKey: 'sort',
        defaultValue: 'five_star'
      }
    ];
    this.fixFilterValues(filterValuesToFix);

    const filterArrayValueToFix = {
      filterValuePath: 'filter.insCompValue',
      filterOptionsPath: 'insuranceCompanies',
      queryKey: 'ins_comp[]'
    };
    this.fixFilterArrayValueDueToQueryString(filterArrayValueToFix);
  },

  methods: {
    updateDependentFilterQuerystrings() {
      const removeKeys = [];
      const extendKeys = [];

      if (this.filter.objectiveValue.value === 'savings') {
        removeKeys.push('objective');
      } else {
        extendKeys.push({ objective: this.filter.objectiveValue.value });
      }

      if (this.filterIssueAgeActualValue?.value === this.issueAgeDefaultValue) {
        removeKeys.push('issue_age');
      } else {
        extendKeys.push({ issue_age: this.filterIssueAgeActualValue?.value });
      }

      if (this.filterStartAgeActualValue?.value === this.startAgeDefaultValue) {
        removeKeys.push('start_age');
      } else {
        extendKeys.push({ start_age: this.filterStartAgeActualValue?.value });
      }

      if (this.filterPremiumTermActualValue?.value === this.premiumTermDefaultValue) {
        removeKeys.push('premium_term');
      } else {
        extendKeys.push({ premium_term: this.filterPremiumTermActualValue?.value });
      }

      if (this.filterCurrencyValue?.value === '1') {
        removeKeys.push('currency');
      } else {
        extendKeys.push({ currency: this.filterCurrencyValue?.value });
      }

      if(this.filterIncomeTermActualValue?.value === this.incomeTermDefaultValue) {
        removeKeys.push('income_term');
      } else {
        extendKeys.push({ income_term: this.filterIncomeTermActualValue?.value });
      }

      const combineQuery = Object.assign({}, this.$route?.query, ...extendKeys);
      const changedQuery = this.$_.omit(combineQuery, removeKeys);
      const sortedQuery = Object.keys(changedQuery)
        .sort()
        .reduce(
          (acc, key) => ({
            ...acc,
            [key]: combineQuery[key]
          }),
          {}
        );

      this.updateQueryString(sortedQuery);
    },

    updateObjectiveValue(mValue) {
      const options = this.$_.get(this, 'filter.objectiveOptions');
      const foundOption = this.locateFilterOption(mValue, options);
      if (foundOption) {
        this.$_.set(this, 'filter.objectiveValue', this.locateFilterOption(mValue, options));
      } else {
        this.$_.set(this, 'filter.objectiveValue', this.locateFilterOption('savings', options));
      }
    },

    updateIssueAgeValue(mValue) {
      const options = this.$_.get(this, 'filterIssueAgeOptions');
      const foundOption = this.locateFilterOption(mValue, options);
      if (foundOption) {
        this.$_.set(
          this,
          'filter.issueAgeValue[' + this.objectiveValue + ']',
          this.locateFilterOption(mValue, options)
        );
      } else {
        this.$_.set(
          this,
          'filter.issueAgeValue[' + this.objectiveValue + ']',
          this.locateFilterOption(this.issueAgeDefaultValue, options)
        );
      }
    },

    updateStartAgeValue(mValue) {
      const options = this.$_.get(this, 'filterStartAgeOptions');
      const foundOption = this.locateFilterOption(mValue, options);
      if (foundOption) {
        this.$_.set(
          this,
          'filter.startAgeValue[' + this.objectiveValue + ']',
          this.locateFilterOption(mValue, options)
        );
      } else {
        this.$_.set(
          this,
          'filter.startAgeValue[' + this.objectiveValue + ']',
          this.locateFilterOption(this.startAgeDefaultValue, options)
        );
      }
    },

    updatePremiumTermValue(mValue) {
      const options = this.$_.get(this, 'filterPremiumTermOptions');
      const foundOption = this.locateFilterOption(mValue, options);
      if (foundOption) {
        this.$_.set(
          this,
          'filter.premiumTermValue[' + this.objectiveValue + ']',
          this.locateFilterOption(mValue, options)
        );
      } else {
        this.$_.set(
          this,
          'filter.premiumTermValue[' + this.objectiveValue + ']',
          this.locateFilterOption(this.premiumTermDefaultValue, options)
        );
      }
    },

    updateCurrencyValue(mValue) {
      const options = this.$_.get(this, 'filterCurrencyOptions');
      const foundOption = this.locateFilterOption(mValue, options);
      if (foundOption) {
        this.$_.set(
          this,
          'filter.currencyValue[' + this.objectiveValue + ']',
          this.locateFilterOption(mValue, options)
        );
      } else {
        this.$_.set(this, 'filter.currencyValue[' + this.objectiveValue + ']', this.locateFilterOption('1', options));
      }
    },

    updateIncomeTermValue(mValue) {
      const options = this.$_.get(this, 'filterIncomeTermOptions');
      const foundOption = this.locateFilterOption(mValue, options);
      if(foundOption) {
        this.$_.set(
          this,
          'filter.incomeTermValue[' + this.objectiveValue + ']',
          this.locateFilterOption(mValue, options)
        );
      } else {
        this.$_.set(
          this,
          'filter.incomeTermValue[' + this.objectiveValue + ']',
          this.locateFilterOption(this.incomeTermDefaultValue, options)
        );
      }
    },

    updateSortingValue(mValue) {
      const options = this.$_.get(this, 'sortingOptions');
      const foundOption = this.locateFilterOption(mValue, options);
      if (foundOption) {
        this.$_.set(this, 'sortingData.sortValue', this.locateFilterOption(mValue, options));
      } else {
        this.$_.set(this, 'sortingData.sortValue', this.locateFilterOption('five_star', options));
      }
    },

    getScore(filter, product) {
      if (filter.objectiveValue?.value === 'savings' && product.savings_result[0]) {
        return product.savings_result[0]?.attributes.savings_total_overall_score;
      } else if (filter.objectiveValue?.value === 'stable_retirement_income' && product.stable_retirement_result[0]) {
        return product.stable_retirement_result[0]?.attributes.stable_retirement_total_overall_score;
      } else if (filter.objectiveValue?.value === 'growth_retirement_income' && product.growth_retirement_result[0]) {
        return product.growth_retirement_result[0]?.attributes.growth_retirement_total_overall_score;
      } else if (filter.objectiveValue?.value === 'longevity' && product.longevity_result[0]) {
        return product.longevity_result[0]?.attributes.longevity_total_overall_score;
      }
    },

    getScoreLabel(filter) {
      if (filter?.objectiveValue?.value === 'savings') {
        return this.$t('products.annuity.as_savingsAnnuityScore');
      } else if (filter?.objectiveValue?.value === 'stable_retirement_income') {
        return this.$t('products.annuity.ar_retirementAnnuityScore');
      } else if (filter?.objectiveValue?.value === 'growth_retirement_income') {
        return this.$t('products.annuity.ar_retirementAnnuityScore');
      } else if (filter?.objectiveValue?.value === 'longevity') {
        return this.$t('products.annuity.al_longevityAnnuityScore');
      }
      return -1;
    },

    getGIRRLabel(filter) {
      if (filter?.objectiveValue?.value === 'savings') {
        return this.$t('products.annuity.as_guaranteedReturnRatioatAge60HightoLow');
      } else if (filter?.objectiveValue?.value === 'stable_retirement_income') {
        if (this.filter?.incomeTermValue[this.filter?.objectiveValue?.value]?.value === '10' || this.filter?.incomeTermValue[this.filter?.objectiveValue?.value]?.value === '20') {
          const age = parseFloat(this.filter?.startAgeValue[this.filter?.objectiveValue?.value]?.value) + parseFloat(this.filter?.incomeTermValue[this.filter?.objectiveValue?.value]?.value);
          return this.$t('products.annuity.ar_guaranteedReturnRatioatAgeHightoLow').replace('$num', age);
        } else {
          return this.$t('products.annuity.ar_guaranteedReturnRatioatAge85HightoLow');
        }
      } else if (filter?.objectiveValue?.value === 'growth_retirement_income') {
        if (this.filter?.incomeTermValue[this.filter?.objectiveValue?.value]?.value === '10' || this.filter?.incomeTermValue[this.filter?.objectiveValue?.value]?.value === '20') {
          const age = parseFloat(this.filter?.startAgeValue[this.filter?.objectiveValue?.value]?.value) + parseFloat(this.filter?.incomeTermValue[this.filter?.objectiveValue?.value]?.value);
          return this.$t('products.annuity.ar_guaranteedReturnRatioatAgeHightoLow').replace('$num', age);
        } else {
          return this.$t('products.annuity.ar_guaranteedReturnRatioatAge85HightoLow');
        }
      } else if (filter?.objectiveValue?.value === 'longevity') {
        return this.$t('products.annuity.al_guaranteedReturnRatioatAge105HightoLow');
      }
      
      return -1;
    },

    getPIRRLabel(filter) {
      if (filter?.objectiveValue?.value === 'savings') {
        return this.$t('products.annuity.as_projectedReturnRatioatAge60HightoLow');
      } else if (filter?.objectiveValue?.value === 'stable_retirement_income') {
        if (this.filter?.incomeTermValue[this.filter?.objectiveValue?.value]?.value === '10' || this.filter?.incomeTermValue[this.filter?.objectiveValue?.value]?.value === '20') {
          const age = parseFloat(this.filter?.startAgeValue[this.filter?.objectiveValue?.value]?.value) + parseFloat(this.filter?.incomeTermValue[this.filter?.objectiveValue?.value]?.value);
          return this.$t('products.annuity.ar_projectedReturnRatioatAgeHightoLow').replace('$num', age);
        } else {
          return this.$t('products.annuity.ar_projectedReturnRatioatAge85HightoLow');
        }
      } else if (filter?.objectiveValue?.value === 'growth_retirement_income') {
        if (this.filter?.incomeTermValue[this.filter?.objectiveValue?.value]?.value === '10' || this.filter?.incomeTermValue[this.filter?.objectiveValue?.value]?.value === '20') {
          const age = parseFloat(this.filter?.startAgeValue[this.filter?.objectiveValue?.value]?.value) + parseFloat(this.filter?.incomeTermValue[this.filter?.objectiveValue?.value]?.value);
          return this.$t('products.annuity.ar_projectedReturnRatioatAgeHightoLow').replace('$num', age);
        } else {
          return this.$t('products.annuity.ar_projectedReturnRatioatAge85HightoLow');
        }
      }
      else if (filter?.objectiveValue?.value === 'longevity') {
        return this.$t('products.annuity.al_projectedReturnRatioatAge105HightoLow');
      }
      return -1;
    },



    getDecoderCTA(item, promotionCTALink) {
      const planName = item.attributes.annuity_plan.data.attributes.annuity_plan_translations.data[0].attributes.name;
      const insurer = item.attributes.annuity_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.insurance_company_translations.data[0].attributes.name;
      const decoderCTAWhatsappLink = this.$generateWhatsappCTALink(this.$t('products.annuity.as_categoryName'), insurer, planName);
      const showCTA = item.attributes.show_cta;
      const saleable = item.attributes.annuity_plan.data.attributes.saleable;
      const productWebsite =
        item.attributes.annuity_plan.data.attributes.annuity_plan_translations.data[0].attributes.product_website;

      if (!showCTA) return null;

      if (saleable) {
        return {
          text: this.$t('products.purchase_now'),
          link:
            process.env.SALES_EXTERNAL_URL +
            '/' +
            (this.currentLocale === 'en' ? 'en' : 'tc') +
            '/purchase?id=' +
            item.attributes.scenario_code
        };
      } else if (promotionCTALink) {
        return {
          text: this.$t('products.purchase_now'),
          link: promotionCTALink
        };
      } else if (productWebsite) {
        return {
          text: this.$t('products.product_website'),
          link: productWebsite,
          type: 'product-website'
        };
      } else {
        return {
          text: '',
          link: decoderCTAWhatsappLink
        };
      }
    },

    getScoreTooltip() {
      switch (this.filter.objectiveValue?.value) {
        case 'savings':
          return this.getTooltipContentByKey('tl_savingsAnnuityScore');
        case 'growth_retirement_income':
          return this.getTooltipContentByKey('tl_growthAnnuityScore');
        case 'stable_retirement_income':
          return this.getTooltipContentByKey('tl_stableAnnuityScore');

        case 'longevity':
          return this.getTooltipContentByKey('al_longevityAnnuityScore');
      }
    },

    getTooltipContentByKey(mKey) {
      return this.annuityTooltips?.Annuity?.ToolTips?.find(({ Key }) => Key === mKey)?.ToolTipContent ?? '';
    }
  },
  components: {
    QuickGuideWrapper
  }
};
